import type { PostProductLikeServiceRequest } from '@musinsa/services-curator';
import { postProductLikeService } from '@musinsa/services-curator';
import { useMutation } from '@tanstack/react-query';

interface UseProductLikeMutationProps {
  onSuccess?: (variables: PostProductLikeServiceRequest) => void;
  onError?: (error: unknown, variables: PostProductLikeServiceRequest) => void;
}

export const useProductLikeMutation = ({ onSuccess, onError }: UseProductLikeMutationProps = {}) =>
  useMutation({
    mutationFn: (request: PostProductLikeServiceRequest) => postProductLikeService(request),
    meta: {
      skipGlobalErrorHandler: true,
    },
    onSuccess: (_data, variables) => {
      onSuccess?.(variables);
    },
    onError: (error, variables) => {
      onError?.(error, variables);
    },
  });
